import * as yup from 'yup';

export const createLoginSchema = (t: (key: string) => string) =>
  yup.object({
    email: yup
      .string()
      .required(t('login.emailRequired'))
      .email(t('login.invalidEmail')),
    password: yup
      .string()
      .required(t('login.passwordRequired'))
      .min(8, t('login.invalidPassword')),
    remember: yup.boolean(),
  });
